import { render } from "./authorization.vue?vue&type=template&id=6ba72362"
import script from "./authorization.vue?vue&type=script&lang=ts"
export * from "./authorization.vue?vue&type=script&lang=ts"

import "./authorization.vue?vue&type=style&index=0&id=6ba72362&lang=less"
script.render = render

export default script